"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _searchInput = _interopRequireDefault(require("./search-input/search-input"));
var _default = _searchInput.default;
exports.default = _default;